var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJamsLogoNoGnuPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1299.5 446.4",
    style: {
      enableBackground: "new 0 0 1299.5 446.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000930;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#00AEFF;}\n\t.st4{opacity:0.5;fill:url(#SVGID_1_);}\n\t.st5{fill:#008BCC;}\n\t.st6{opacity:0.5;fill:url(#SVGID_2_);}\n\t.st7{fill:#4DC6FF;}\n\t.st8{opacity:0.4;fill:url(#SVGID_3_);}\n\t.st9{opacity:0.5;fill:url(#SVGID_4_);}\n\t.st10{opacity:0.5;fill:url(#SVGID_5_);}\n\t.st11{opacity:0.4;fill:url(#SVGID_6_);}\n\t.st12{fill:#66CFFF;}\n\t.st13{opacity:0.5;fill:url(#SVGID_7_);}\n\t.st14{fill:#1AB6FF;}\n\t.st15{fill:#009DE6;}\n\t.st16{opacity:0.6;fill:url(#SVGID_8_);}\n\t.st17{fill:url(#SVGID_9_);}\n\t.st18{opacity:0.5;fill:url(#SVGID_10_);}\n\t.st19{fill:url(#SVGID_11_);}\n\t.st20{fill:url(#SVGID_12_);}\n\t.st21{fill:url(#SVGID_13_);}\n\t.st22{fill:url(#SVGID_14_);}\n\t.st23{fill:url(#SVGID_15_);}\n\t.st24{fill:url(#SVGID_16_);}\n\t.st25{opacity:0.4;fill:url(#SVGID_17_);enable-background:new    ;}\n\t.st26{fill:url(#SVGID_18_);}\n\t.st27{fill:url(#SVGID_19_);}\n\t.st28{fill:url(#SVGID_20_);}\n\t.st29{fill:url(#SVGID_21_);}\n\t.st30{fill:url(#SVGID_22_);}\n\t.st31{fill:url(#SVGID_23_);}\n\t.st32{fill:url(#SVGID_24_);}\n\t.st33{fill:url(#SVGID_25_);}\n\t.st34{fill:url(#SVGID_26_);}\n\t.st35{opacity:0.2;fill:url(#SVGID_27_);enable-background:new    ;}\n\t.st36{fill:url(#SVGID_28_);}\n\t.st37{fill:url(#SVGID_29_);}\n\t.st38{opacity:0.25;fill:url(#SVGID_30_);enable-background:new    ;}\n\t.st39{fill:url(#SVGID_31_);}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{opacity:0.2;fill:url(#SVGID_33_);enable-background:new    ;}\n\t.st42{fill:url(#SVGID_34_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.1,87.7v111.9c0,64.3-51.9,116.6-116.2,116.6v-31.5c46.8-0.4,84.7-38.3,84.7-85.1V87.7H500.1z  M505.6,31.1c0-11.9-9.8-21.3-21.3-21.3c-11.9,0-21.3,9.4-21.3,21.3c0,11.5,9.4,21.3,21.3,21.3C495.8,52.4,505.6,42.6,505.6,31.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M755,314.1h-31.5v-34.5c-21.3,22.6-51.5,36.6-84.7,36.6c-64.3,0-116.6-52.4-116.6-116.6 S574.5,83.4,638.8,83.4c64.3,0,116.2,51.9,116.2,116.2V314.1z M723.5,199.6c0-46.8-37.9-84.7-84.7-84.7 c-46.8,0-85.1,37.9-85.1,84.7c0,46.8,38.3,85.1,85.1,85.1C685.6,284.8,723.5,246.5,723.5,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1049.1,314.1V166c0-28.9-23.4-51.9-52.4-51.9c-28.9,0-52.4,23.4-52.4,52.4v147.7h-31.5V166 c0-28.9-23.4-51.9-52.4-51.9c-28.5,0-51.9,23.4-51.9,52.4v147.7h-31.5V166c0-46.4,37.5-83.4,83.4-83.4c28.1,0,52.8,13.6,68.1,34.9 c15.3-21.3,40-34.9,68.1-34.9c46.4,0,83.9,37.5,83.9,83.9v147.7H1049.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1273,217.1c-7.9-8.4-17.4-14.5-28.5-18c-10.9-3.4-25.4-6.9-43.2-10.3c-14.4-2.5-25.8-5-33.8-7.4 c-7.9-2.3-14.6-6-19.9-10.8c-5.2-4.8-7.7-11-7.7-19c0-10.5,4.5-18.8,13.9-25.3c9.4-6.5,23.7-9.9,42.5-9.9c25,0,46.9,6.3,64.9,18.8 c0.5,0.3,1,0.4,1.5,0.3c0.5-0.1,1-0.5,1.2-0.9l13.2-24.3c0.5-0.9,0.2-2-0.6-2.5c-9.5-6.3-21.7-11.5-36.3-15.4 c-14.6-3.9-29.3-5.8-43.9-5.8c-28.1,0-50.4,6.1-66.3,18.3c-16,12.2-24.2,28.2-24.2,47.5c0,15.5,4.1,27.8,12.2,36.6 c8,8.7,17.8,15,29.1,18.6c11.1,3.6,25.9,7.1,44.1,10.5c13.5,2.2,24.4,4.6,32.5,7c7.9,2.3,14.6,5.8,19.7,10.2 c5,4.3,7.4,10.2,7.4,17.9c0,11-4.5,19.4-13.8,25.4c-9.4,6.1-24.3,9.3-44.3,9.3c-15,0-29.7-2.3-43.7-6.9 c-13.9-4.6-25.6-10.6-34.7-17.8c-0.4-0.3-1-0.5-1.5-0.4c-0.5,0.1-1,0.4-1.3,0.9l-13.6,23.8c-0.5,0.8-0.3,1.8,0.4,2.4 c9.5,8.1,22.8,14.9,39.6,20.2c16.7,5.3,34.4,8,52.7,8c29.2,0,52.4-5.9,69-17.6c16.8-11.8,25.3-28,25.3-48.2 C1285,237.5,1281,225.6,1273,217.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M946,363.8c-7.8,0-15.3,2.8-21.2,7.7v-16h-11.5v40.6c0,17.9,14.7,32.5,32.7,32.5c18.1,0,32.8-14.6,32.8-32.5 C978.8,378.3,964.1,363.8,946,363.8z M967.3,396.1c0,11.6-9.6,21.1-21.3,21.1c-11.7,0-21.2-9.5-21.2-21.1c0-11.6,9.5-21,21.2-21 C957.8,375.1,967.3,384.6,967.3,396.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1038.8,396.1c0,11.6-9.5,21.1-21.2,21.1c-11.8,0-21.3-9.5-21.3-21.1v-31.7h-11.5v31.7 c0,17.9,14.7,32.5,32.8,32.5c7.8,0,15.3-2.8,21.2-7.7V437h11.5v-72.5h-11.5V396.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1100.9,344.1c-4.1,0-7.2,3.1-7.2,7.2c0,3.9,3.2,7.2,7.2,7.2c3.9,0,7.2-3.3,7.2-7.2 C1108.2,347.3,1104.9,344.1,1100.9,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1095.2,396c0,11.5-9.5,21-21.2,21.1l-1.5,0v11.4h1.5c18,0,32.7-14.6,32.7-32.5v-31.2h-11.5V396z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1243.1,363.4c-7.1,0-13.7,3-18.3,8.3c-4.6-5.3-11.1-8.3-18.3-8.3c-13.2,0-23.9,10.6-23.9,23.7v40.9h11.5 v-40.7c0-6.8,5.6-12.4,12.4-12.4c6.9,0,12.5,5.5,12.5,12.3v40.9h11.5v-40.7c0-6.8,5.6-12.4,12.5-12.4s12.5,5.5,12.5,12.3v40.9 h11.5v-40.7C1267.1,374.1,1256.3,363.4,1243.1,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1278.8,358.4c4.1,0,7.2-3.1,7.2-7.2c0-3.9-3.2-7.2-7.2-7.2c-4,0-7.2,3.2-7.2,7.2 C1271.5,355.2,1274.7,358.4,1278.8,358.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1273,
    y: 364.8,
    className: "st0",
    width: 11.5,
    height: 63.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1144.4,363.7c-18.1,0-32.8,14.6-32.8,32.5s14.7,32.5,32.8,32.5h32.8v-32.5 C1177.2,378.3,1162.5,363.7,1144.4,363.7z M1165.9,396.2v21.3h-21.5c-11.9,0-21.5-9.6-21.5-21.3s9.7-21.3,21.5-21.3 C1156.3,374.8,1165.9,384.4,1165.9,396.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.4,101.9c14.1-21.6,26.7-38.2,37.6-50.9c0,0,0,0,0,0.1c0,0,0.1-0.1,0.1-0.1 C124.4,6.1,104.6,8.6,103.5,8.9c-0.6,0-1.4,0.3-2,0.6c-1.4,0.6-2.8,5.1-2.8,5.1s-8.5,24.8,25.9,90.9L127.4,101.9L127.4,101.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9914,
    y1: 57.1103,
    x2: 165.387,
    y2: 57.1103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.7,101.9c14.1-21.6,26.7-38.2,37.6-50.9c0,0,0,0,0,0.1c0,0,0.1-0.1,0.1-0.1 C124.7,6.1,104.9,8.6,103.8,8.9c-0.6,0-1.4,0.3-2,0.6c-1.4,0.6-2.8,5.1-2.8,5.1s-8.5,24.8,25.9,90.9L127.7,101.9L127.7,101.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241.3,161.6c74.3,12,84.9,30.5,84.9,30.5c0,1.1,0,2.3,0,3.4c0,0.6-0.3,1.1-0.6,2c-0.3,0.9-6.8,15.1-55,25.3 L241.3,161.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.7863,
    y1: 161.5575,
    x2: 283.7863,
    y2: 222.7958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008BCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M241.3,161.6c74.3,12,84.9,30.5,84.9,30.5c0,1.1,0,2.3,0,3.4c0,0.6-0.3,1.1-0.6,2c-0.3,0.9-6.8,15.1-55,25.3 L241.3,161.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.4,222.8c-16.8,44.7-7.7,57.3-7.2,58.4c0.3,0.6,0.6,1.1,1.1,1.4c1.1,0,2.3-0.3,3.4-0.6 c0,0,30.5-1.4,66.1-52.1L53.4,222.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.209,
    y1: 265.3497,
    x2: 60.3301,
    y2: 218.7941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DC6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.4,222.8c-16.8,44.7-7.7,57.3-7.2,58.4c0.3,0.6,0.9,1.4,1.4,1.7c1.1,0,2-0.6,3.1-0.9 c0,0,30.5-1.4,66.1-52.1L53.4,222.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.6,222.2c55.3,63.2,74.6,59.5,74.6,59.5c1.1,0.3,2.6,0.6,3.7,0.6c0.6-0.3,0.9-0.9,1.1-1.4 c0.9-1.1,14.2-27.1-38.7-119.3L200.6,222.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.1831,
    y1: 261.7554,
    x2: 279.3609,
    y2: 183.505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.3,222.2c55.3,63.2,74.6,59.5,74.6,59.5c1.1,0.3,2.6,0.6,3.7,0.6c0.6-0.3,0.9-0.9,1.1-1.4 c0.9-1.1,14.5-27.1-38.4-119.3L200.3,222.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.1,230.2C10.9,226.8,1.5,198.9,1,197.4c-0.3-0.6-0.6-1.1-0.6-2c0.3-2,4.3-5.7,4.3-5.7 s30.2-18.5,80.6-28.5L129.1,230.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.4643,
    y1: 169.6463,
    x2: 96.1567,
    y2: 267.8404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008BCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008BCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M129.1,230.2C10.9,226.8,1.5,198.9,1,197.4c-0.3-0.6-0.6-1.1-0.6-2c0.3-2,4.3-5.7,4.3-5.7 s30.2-18.5,80.6-28.5L129.1,230.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.7,98.6C237.6,28.3,226,12,226,12c-0.3-0.9-0.6-2-0.9-2.8c-0.6-0.3-1.1-0.3-2-0.6 c-1.4-0.3-33-2.6-95.7,93.3L207.7,98.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.2546,
    y1: 22.7968,
    x2: 143.065,
    y2: 117.9864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DC6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M207.7,99.1C237.6,28.7,226,12.5,226,12.5c-0.3-0.9-0.6-2-0.9-2.8c-0.6-0.3-1.1-0.3-2-0.6 c-1.4-0.3-33-2.6-95.7,93.3L207.7,99.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M160,271.7c-40.4,43.9-57.1,44.8-58.2,44.8c-1.7-0.6-3.4-1.4-4.8-2.3l-49.7-31.6 c20.8-4.6,42.8-33.7,69.6-65.3L160,271.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.8499,
    y1: 226.514,
    x2: 85.7377,
    y2: 308.1147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001818783,
    style: {
      stopColor: "#66CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04749321,
    style: {
      stopColor: "#80D7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1187,
    style: {
      stopColor: "#A2E2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1977,
    style: {
      stopColor: "#BFEBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2851,
    style: {
      stopColor: "#D7F2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3845,
    style: {
      stopColor: "#E9F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5029,
    style: {
      stopColor: "#F5FCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160,271.7c-40.4,43.9-57.7,44.8-58.8,44.8c-1.7-0.6-3.4-1.4-4.8-2.3l-49.3-31.3c20.8-4.6,43-34,69.8-65.6 L160,271.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54.8,107.4c-17.9-46.1-9.1-60.7-8.5-61.5c1.1-1.4,2.6-2.6,4-3.4l51.3-33c-4.3,20.2,4.8,53,21.6,88.9 L54.8,107.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M238,166.5c38.5,5.4,73.7,14.4,88.2,28.9l-0.3-58.4c0-1.7-0.3-3.7-0.6-5.4c-0.3-0.9-9-16.4-55.4-26.3 L238,166.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.7876,
    y1: 131.5979,
    x2: 336.0161,
    y2: 178.4952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001818783,
    style: {
      stopColor: "#009DE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04656537,
    style: {
      stopColor: "#2BADEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1007,
    style: {
      stopColor: "#57BEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    style: {
      stopColor: "#7FCEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2246,
    style: {
      stopColor: "#A2DBF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#BFE6F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    style: {
      stopColor: "#D7EFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4586,
    style: {
      stopColor: "#E9F6FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5627,
    style: {
      stopColor: "#F5FBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M238,166.5c38.5,5.4,73.7,14.4,88.2,28.9v-58.4c0-1.7-0.3-3.7-0.6-5.4c-0.3-0.9-9.3-16.4-55.7-26.3 L238,166.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M206.3,97.8c-8.5-0.3-27.1-1.1-43-1.1C17.8,96.6,1.8,130.2,1,131.9c-0.6,1.7-0.6,3.4-0.6,5.4V196 c14.2-14.2,45.3-21.9,83.2-27.6c24.5-3.4,49-5.4,73.8-5.7c4.6,0,9.1,0,13.7,0C171,162.4,214.9,98,206.3,97.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.8,196C300,74.1,281.2,47.3,280.4,45.9c-1.1-1.4-2.6-2.6-4-3.4l-51.3-33c7.1,33.6-27.1,93.7-66.4,153.2 c13.1,20.2,27.3,42.7,41.9,59.5C203.5,218.8,215.4,204.3,220.8,196z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.975,
    y1: -372.92,
    x2: 190.576,
    y2: -533.1802,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#109EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M204.6,226.2c0.3-0.3,0.6-0.3,0.6-0.6c-15.1-17.9-29.1-36.7-41.9-56.1c-0.3,0.3-0.6,0.6-0.6,1.1 C162.4,170.4,190.1,214,204.6,226.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205.2,225.6c-15.1-17.9-29.1-36.7-41.9-56.1c-1.4-2.3-3.1-4.6-4.6-6.8c-24.8,0-49.6,2-74.1,5.4 c0.9,1.4,12.2,20.5,20.5,33.3c79.2,121.9,116.2,117.1,117.9,116.8c1.7-0.6,3.4-1.4,4.8-2.3l51-33.6 C258.2,277.5,231.4,256.1,205.2,225.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.807,
    y1: 140.3285,
    x2: 232.6371,
    y2: 313.2392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01878715,
    style: {
      stopColor: "#2BBBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07450032,
    style: {
      stopColor: "#57C9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#7FD6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2019,
    style: {
      stopColor: "#A2E1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2735,
    style: {
      stopColor: "#BFEBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3527,
    style: {
      stopColor: "#D7F2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4427,
    style: {
      stopColor: "#E9F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    style: {
      stopColor: "#F5FCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6912,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M205.2,225.6c-15.1-17.9-29.1-36.7-41.9-56.1c-1.4-2.3-3.1-4.6-4.6-6.8c-24.8,0-49.6,2-74.1,5.4 c0.9,1.4,12.2,20.5,20.5,33.3c79.2,121.9,116.2,117.1,117.9,116.8c1.7-0.6,3.4-1.4,4.8-2.3l51-33.6 C258.2,277.5,231.4,256.1,205.2,225.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.6281,
    y1: -500.104,
    x2: 168.7209,
    y2: -485.0456,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "156.4,156.4 176.4,155.9 166.6,174.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7782,
    y1: -506.6081,
    x2: 292.7782,
    y2: -610.1052,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0704,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    style: {
      stopColor: "#2E5589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3608,
    style: {
      stopColor: "#2B5E97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#29629C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6392,
    style: {
      stopColor: "#2B5E97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    style: {
      stopColor: "#2E5589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9296,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M242.8,161.2c73.4,11.8,83.8,30.1,83.8,30.1c0,1.1,0,2.2,0,3.4c0,0.6-0.3,1.1-0.6,2 c-0.3,0.8-7.6,16-55.1,26.2L242.8,161.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.6356,
    y1: -617.9026,
    x2: 96.2178,
    y2: -558.1093,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252B59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859,
    style: {
      stopColor: "#2B3A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2267,
    style: {
      stopColor: "#2E4A7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3658,
    style: {
      stopColor: "#2E5487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2D578C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6342,
    style: {
      stopColor: "#2E5487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7733,
    style: {
      stopColor: "#2E4A7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    style: {
      stopColor: "#2B3A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#252B59"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M57.7,220.3c-16.6,44.2-8.2,57.9-7.6,59.1c0.3,0.6,0.6,1.1,1.1,1.4c1.1,0,2.2-0.3,3.4-0.6 c0,0,30.1-1.4,65.2-51.5L57.7,220.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6792,
    y1: -414.9013,
    x2: 103.0936,
    y2: -350.0509,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0284,
    style: {
      stopColor: "#1E1E4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1353,
    style: {
      stopColor: "#283261"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2468,
    style: {
      stopColor: "#2D4172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#2E4A7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E4D7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6177,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    style: {
      stopColor: "#273160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181844"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M167.4,51.8c-40.2-44.2-59.6-41.6-60.7-41.3c-0.6,0-1.4,0.3-2,0.6c-1.4,0.6-2.8,5.1-2.8,5.1 s-8.4,24.5,25.6,89.7L167.4,51.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.744,
    y1: -625.0323,
    x2: 225.8019,
    y2: -486.6978,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0284,
    style: {
      stopColor: "#1E1E4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1353,
    style: {
      stopColor: "#283261"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2468,
    style: {
      stopColor: "#2D4172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#2E4A7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2E4D7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6177,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    style: {
      stopColor: "#273160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181844"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M202.6,221.1c54.6,62.4,73.7,58.8,73.7,58.8c1.1,0.3,2.5,0.6,3.7,0.6c0.6-0.3,0.8-0.8,1.1-1.4 c0.8-1.1,16.3-26.4-36-117.6L202.6,221.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.4995,
    y1: -506.6073,
    x2: 76.4995,
    y2: -610.1024,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0704,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    style: {
      stopColor: "#2E5589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3608,
    style: {
      stopColor: "#2B5E97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#29629C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6392,
    style: {
      stopColor: "#2B5E97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    style: {
      stopColor: "#2E5589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9296,
    style: {
      stopColor: "#2D4576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M132,230.7c-112.5-4.8-126-32.6-126.6-34c-0.3-0.6-0.6-1.1-0.6-2c0.3-2,4.2-5.6,4.2-5.6s29.8-18.3,79.6-28.1 L132,230.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.4038,
    y1: -405.0396,
    x2: 174.0339,
    y2: -405.0396,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M164.3,48.4c-14.1,15.2-27,31.5-38.8,48.4h2.8c8.7-11,30.4-38.5,37.7-46.4L164.3,48.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.0131,
    y1: -448.0157,
    x2: 187.0131,
    y2: -350.3966,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252B59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2D578C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    style: {
      stopColor: "#2D5588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8038,
    style: {
      stopColor: "#2E4F80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    style: {
      stopColor: "#2D4474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    style: {
      stopColor: "#283463"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#252B59"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M209.6,99.1c29.5-69.5,18-85.5,18-85.5c-0.3-0.8-0.6-2-0.8-2.8c-0.6-0.3-1.1-0.3-2-0.6 C223.4,9.9,192.7,6,128,96.5L209.6,99.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.9865,
    y1: -637.535,
    x2: 276.3237,
    y2: -367.9654,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08239999,
    style: {
      stopColor: "#177EBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1675,
    style: {
      stopColor: "#0E91D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#10A2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    style: {
      stopColor: "#18ACEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#24B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#28B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#24B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#18ACEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    style: {
      stopColor: "#10A2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8325,
    style: {
      stopColor: "#0E91D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9176,
    style: {
      stopColor: "#177EBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M165.2,273.4c-39.9,43.3-59.1,40.8-60.2,40.8c-1.7-0.6-3.4-1.4-4.8-2.2L51.5,281 c20.5-4.5,45.8-28.7,72.3-59.9L165.2,273.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.8875,
    y1: -642.9006,
    x2: 152.5226,
    y2: -579.6575,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5D95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08220001,
    style: {
      stopColor: "#246EAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1808,
    style: {
      stopColor: "#1B79B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    style: {
      stopColor: "#1080C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0E81C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6993,
    style: {
      stopColor: "#1080C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8192,
    style: {
      stopColor: "#1B79B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#246EAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C5D95"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M166.9,275.1c-39.9,43.3-59.1,40.8-60.2,40.8c-1.7-0.6-3.4-1.4-4.8-2.2l-50.3-32.9c20.5-4.5,47.5-27,74-58.2 L166.9,275.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.3674,
    y1: -366.1688,
    x2: 239.3868,
    y2: -639.5338,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5D95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#2A6199"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1407,
    style: {
      stopColor: "#1C79B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2631,
    style: {
      stopColor: "#0A8CCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3837,
    style: {
      stopColor: "#0B97D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0E9AD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6163,
    style: {
      stopColor: "#0B97D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7369,
    style: {
      stopColor: "#0A8CCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    style: {
      stopColor: "#1C79B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9824,
    style: {
      stopColor: "#2A6199"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C5D95"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M60.3,106.4c-17.7-45.6-9-59.9-8.4-60.7c1.1-1.4,2.5-2.5,3.9-3.4l48.7-30.9c-4.2,20,6.5,50.6,23.1,86.3 L60.3,106.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.001,
    y1: -637.7335,
    x2: 147.5363,
    y2: -504.8962,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5D95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0257,
    style: {
      stopColor: "#2A6199"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2053,
    style: {
      stopColor: "#1C79B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    style: {
      stopColor: "#0A8CCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    style: {
      stopColor: "#0B97D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7296,
    style: {
      stopColor: "#0E9AD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7925,
    style: {
      stopColor: "#0B97D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8577,
    style: {
      stopColor: "#0A8CCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9239,
    style: {
      stopColor: "#1C79B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9905,
    style: {
      stopColor: "#2A6199"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C5D95"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M162.9,160.4c-24.5,0-48.9,2-73.1,5.3c0.8,1.4,12.1,20.2,20.2,32.9C188.2,319,224.8,314.2,226.5,313.9 c1.7-0.6,3.4-1.4,4.8-2.2l48.7-30.9C246.7,273.7,200.6,219.7,162.9,160.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5715,
    y1: -433.0317,
    x2: 80.0374,
    y2: -359.1097,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5D95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08220001,
    style: {
      stopColor: "#246EAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1808,
    style: {
      stopColor: "#1B79B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    style: {
      stopColor: "#1080C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0E81C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6993,
    style: {
      stopColor: "#1080C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8192,
    style: {
      stopColor: "#1B79B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9178,
    style: {
      stopColor: "#246EAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C5D95"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M58.6,107.8c-17.7-45.6-9-59.9-8.4-60.7c1.1-1.4,2.5-2.5,3.9-3.4L104.7,11c-4.2,20,4.8,52.3,21.4,87.7 L58.6,107.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.1225,
    y1: -482.8043,
    x2: 13.1914,
    y2: -482.8043,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128,
    style: {
      stopColor: "#256BA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#0B83C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2115,
    style: {
      stopColor: "#1797D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    style: {
      stopColor: "#25A3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4066,
    style: {
      stopColor: "#27ABE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#2AAEEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#27ABE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    style: {
      stopColor: "#25A3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7885,
    style: {
      stopColor: "#1797D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    style: {
      stopColor: "#0B83C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872,
    style: {
      stopColor: "#256BA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M242.5,167.1c38,5.3,69.5,13.2,83.8,27.6V137c0-1.7-0.3-3.7-0.6-5.3c-0.3-0.8-7.6-15.7-53.4-25.6 L242.5,167.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4093,
    y1: -478.2634,
    x2: 332.8521,
    y2: -483.1914,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E5284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0061,
    style: {
      stopColor: "#2E5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912,
    style: {
      stopColor: "#29649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1876,
    style: {
      stopColor: "#236FAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3049,
    style: {
      stopColor: "#1D77B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1C78B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6951,
    style: {
      stopColor: "#1D77B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8124,
    style: {
      stopColor: "#236FAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    style: {
      stopColor: "#29649D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#2E5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E5284"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M242.5,165.2c38,5.3,69.5,15.5,83.8,29.8v-60.2c0-1.7-0.3-3.7-0.6-5.3c-0.3-0.8-7.6-15.7-53.4-25.6 L242.5,165.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.9377,
    y1: -478.5856,
    x2: 177.9198,
    y2: -478.5856,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0225,
    style: {
      stopColor: "#256BA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1971,
    style: {
      stopColor: "#0B83C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3718,
    style: {
      stopColor: "#1797D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5447,
    style: {
      stopColor: "#25A3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    style: {
      stopColor: "#27ABE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8788,
    style: {
      stopColor: "#2AAEEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9015,
    style: {
      stopColor: "#27ABE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#25A3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9487,
    style: {
      stopColor: "#1797D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9728,
    style: {
      stopColor: "#0B83C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    style: {
      stopColor: "#256BA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M208.2,98.2c-8.4-0.3-26.7-1.1-42.5-1.1C22,97.1,6.3,130.3,5.4,132c-0.6,1.7-0.6,3.4-0.6,5.3v57.9 C18.9,181.2,49.6,173.6,87,168c24.2-3.4,48.4-5.3,72.8-5.6c4.5,0,9,0,13.5,0C173.3,162.1,216.6,98.5,208.2,98.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.9572,
    y1: -435.7314,
    x2: 66.953,
    y2: -427.0119,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M126.1,93.7c-30.1,1.4-51.7,3.7-69.7,8.7l0.8,2.2c1.7-0.3,3.7-0.8,5.3-1.1c21.7-3.4,43.3-5.6,65-6.5 L126.1,93.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.0278,
    y1: -488.9058,
    x2: 16.8067,
    y2: -464.2652,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#109EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M208.2,96c-8.4-0.3-26.7-1.1-42.5-1.1C22,94.8,6.3,128,5.4,129.7c-0.6,1.7-0.6,3.4-0.6,5.3v60.2 c14.1-14.1,44.7-23.9,82.1-29.5c24.2-3.4,48.4-5.3,72.8-5.6c4.5,0,9,0,13.5,0C179.8,160.1,216.6,96.3,208.2,96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.2072,
    y1: -367.3556,
    x2: 189.8825,
    y2: -510.8593,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1238,
    style: {
      stopColor: "#177EBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2516,
    style: {
      stopColor: "#0E91D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3797,
    style: {
      stopColor: "#10A2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5064,
    style: {
      stopColor: "#18ACEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    style: {
      stopColor: "#24B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7513,
    style: {
      stopColor: "#28B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    style: {
      stopColor: "#24B1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8324,
    style: {
      stopColor: "#18ACEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    style: {
      stopColor: "#10A2E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    style: {
      stopColor: "#0E91D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#177EBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M165.7,164.9c39.1-58.8,68.1-120.4,61-153.8L275.4,42c1.4,0.8,2.8,2,3.9,3.4c0.8,1.4,20,32.9-58.2,153.3 c-5.6,9-11,19.4-12.9,20.2c-11.5-11.2-35.4-43.9-41.3-52C166,165.7,165.7,164.9,165.7,164.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.8231,
    y1: -439.6182,
    x2: 253.4852,
    y2: -496.5504,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M274,104.1c-8.7,21.9-19.1,43-31.2,63l3.7,0.6c15.5-26.7,24.5-46.4,30.7-63L274,104.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.6096,
    y1: -370.5822,
    x2: 187.0205,
    y2: -527.4453,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#109EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M223.1,200.3C301.3,79.9,282.2,48.4,281.3,47c-1.1-1.4-2.5-2.5-3.9-3.4L226.8,11 c7,33.2-20.8,97.3-59.6,156.1c12.9,20,26.4,39.4,40.8,56C210.7,219.7,217.8,208.5,223.1,200.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.0814,
    y1: -374.1085,
    x2: 192.7566,
    y2: -532.3528,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2867A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0382,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2081,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#109EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2867A2"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M206.5,225.1c0.3-0.3,0.6-0.3,0.6-0.6c-14.9-17.7-28.7-36.3-41.3-55.4c-0.3,0.3-0.6,0.6-0.6,1.1 C164.9,169.9,192.2,213,206.5,225.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.8843,
    y1: -554.018,
    x2: 162.513,
    y2: -612.6138,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3B6A"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M165.7,276.3c-0.6-0.8-29.2-34.6-42.5-54.6l-2.2,2.5c12.9,18.8,27.3,36.8,43,54L165.7,276.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.968,
    y1: -493.743,
    x2: 207.4306,
    y2: -652.2678,
    gradientTransform: "matrix(1 0 0 -1 -8.0854 -332.4089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E5284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0244,
    style: {
      stopColor: "#2C5C92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0888,
    style: {
      stopColor: "#2075B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1599,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2403,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3378,
    style: {
      stopColor: "#0E9CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#109EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6718,
    style: {
      stopColor: "#0C9BDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7751,
    style: {
      stopColor: "#0A94D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    style: {
      stopColor: "#0B86C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9351,
    style: {
      stopColor: "#2174B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C5D95"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M207.1,224.5c-14.9-17.7-28.7-36.3-41.3-55.4c-1.4-2.2-3.1-4.5-4.5-6.7c-24.5,0-48.9,2-73.1,5.3 c0.8,1.4,12.1,20.2,20.2,32.9C186.5,321,223.1,316.2,224.8,315.9c1.7-0.6,3.4-1.4,4.8-2.2l50.3-32.6 C259.4,276.3,232.9,254.6,207.1,224.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.7,316c-6.5,0-25.3-3.7-57.9-38.5c-32.6,34.1-51.1,37.2-57.5,36.8c-0.4,0-0.9-0.1-1.2-0.2 c-2.2-0.7-4.2-1.8-5.4-2.5l-47.5-30.2c-0.2-0.1-0.4-0.3-0.5-0.4c-1.2-0.7-1.8-2-2.2-2.7c-3.4-5.9-7-20.8,5.2-55.1 c-38.7-8.4-47.1-20.8-48.9-25.9c-0.2-0.3-0.3-0.7-0.5-1.2c-0.2-0.5-0.4-1-0.4-1.6v-60.1c0-0.7,0.2-1.3,0.4-1.8 c0.1-0.4,0.2-0.7,0.3-1.1c0.1-0.2,0.1-0.3,0.2-0.5c1.9-3.9,11.1-16.8,49.6-26.1c-15-41.5-6.8-55.6-5.8-57.2 c0.4-0.5,0.7-0.9,1.1-1.3c0.3-0.6,0.7-1,1.2-1.4l2-1.3c0.3-0.2,0.5-0.4,0.7-0.5l49.3-31.8c0.1-0.1,0.2-0.1,0.4-0.2 c0.4-0.2,1.8-0.9,3.3-0.9c3.5-0.5,22.9-0.8,59.6,38.5c37.2-42,55.9-38.9,56.7-38.7c0.2,0,0.3,0.1,0.5,0.1 c0.2,0.1,0.4,0.1,0.6,0.1c0.5,0.1,1.1,0.2,1.9,0.6c0.5,0.3,1,0.6,1.3,1.1l48.4,31.2c0.9,0.5,1.8,1.2,2.8,2.1 c0.1,0.1,0.2,0.2,0.2,0.2c0.6,0.6,1.2,1.1,1.7,1.8c0.1,0.1,0.2,0.3,0.3,0.4c2.2,3.7,8.2,18.5-5.8,57.1 c43.7,10.5,49.3,25.6,49.5,26.2c0.1,0.2,0.1,0.4,0.1,0.6c0.3,1.7,0.6,3.9,0.6,5.8v35.7l0.2,16.6c0,0.2,0.1,0.4,0.1,0.6v3.3 c0,1.1-0.3,1.9-0.6,2.6l-0.2,0.5c-0.9,2.7-7.5,16.2-50.4,26.1c14.4,38.4,8.2,52,6.1,55.1c-0.2,0.4-0.4,0.8-0.8,1.3 c-0.3,0.8-0.8,1.4-1.5,1.9l-49.1,31.8c-1.4,0.8-3.3,1.9-5.5,2.6c-0.2,0.1-0.4,0.1-0.6,0.1C223.3,315.9,222.6,316,221.7,316z  M165.4,269.7c1,0,2.1,0.4,2.8,1.2c34.4,37.1,51.9,37.5,54.1,37.4c1.1-0.4,2.3-1,3.5-1.7l43.6-28.3c-0.2-0.6-0.3-1.2-0.2-1.8 c0.2-1.8,1.7-3.2,3.6-3.4c0.4,0,1.1,0,1.4,0.1c0.3,0.1,0.6,0.1,0.9,0.2c1.2-2.4,6-16-10.2-55.4c-0.8-1.9,0.1-4.1,2-5 c1.9-0.9,4.1-0.1,5,1.8l0.5,0.9c40.9-9.2,45.8-21.1,45.9-21.3l0.3-1V191c0-0.2,0-0.3,0-0.5l-0.2-17.1v-35.8 c0-1.3-0.2-2.9-0.4-4.1c-0.8-1.3-9-13.4-48.1-22c-1.1-0.2-2-0.9-2.6-1.9c-0.5-1-0.6-2.2-0.2-3.2c14.7-38.6,9-52.4,8-54.3 c-0.3-0.3-0.5-0.5-0.8-0.8c0,0-0.1-0.1-0.1-0.1c-0.6-0.5-1.2-1-1.7-1.3L223.1,18c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.1,0-0.3-0.1-0.4-0.1c-1.3-0.1-18.5,0.3-52.1,39.5c-1.3,1.5-3.4,1.8-5,0.7c-0.4-0.3-0.8-0.6-1.1-1.1 c-37.5-41-55.2-38.9-55.4-38.8c-0.2,0-0.5,0.1-0.7,0.1l0,0c0,0,0,0-0.1,0.1L58.7,49.8c-0.1,0-0.6,0.4-0.6,0.4l-0.8,0.5 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.4,0.3-0.8,0.7-1.1,1.1c0,0,0,0,0,0c0,0-7.4,13.1,8.3,54c0.4,1,0.3,2.2-0.2,3.2 c-0.5,1-1.5,1.7-2.6,1.9C22.2,120,14,132,12.7,134.1c-0.1,0.4-0.2,0.8-0.2,1.3c0,0.2,0,0.3-0.1,0.5v57.7c0,0.1,0,0.1,0,0.2 c0.1,0.1,0.2,0.5,0.2,0.6c0.6,1.6,6.1,13.9,47.7,22.1c1.1,0.2,2.1,0.9,2.6,1.9c0.6,1,0.6,2.2,0.2,3.2 c-13.8,36.7-9.1,49.7-7.3,52.8c0,0.1,0.2,0.3,0.2,0.4c0,0,0,0,0,0l0.1,0c0.3,0.2,0.5,0.3,0.7,0.6l46.7,29.7 c1,0.6,2.2,1.2,3.3,1.6c4.6-0.1,21.4-2.8,52.5-35.7c1.2-1.2,3-1.5,4.4-0.8C164.4,269.8,164.9,269.7,165.4,269.7z M55.6,274.3 l0.3,0.2C55.8,274.4,55.7,274.4,55.6,274.3z M165.5,172.7C165.5,172.7,165.5,172.7,165.5,172.7c-1.4,0-2.6-0.7-3.3-1.8 c-0.7-1.1-1.4-2.1-2.1-3.2c-0.4-0.5-0.7-1.1-1.1-1.6c-0.1,0-0.2,0-0.3,0l-2,0c0,0,0,0,0,0c-2.1,0-3.8-1.7-3.8-3.8 c0-2.1,1.7-3.9,3.8-3.9l1.3,0c0.6,0,1.2,0,1.7,0h10c1.4,0,2.7,0.8,3.4,2s0.6,2.7-0.1,3.9l-1,1.5c-1.1,1.7-2.2,3.4-3.3,5.1 C168,172.1,166.8,172.7,165.5,172.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.7,314.4c-1,0-1.9-0.1-2.7-0.2c-0.4,0-0.6-0.1-1-0.2c-2.2-0.7-4.2-1.8-5.4-2.5l-47.5-30.2 c-1.3-0.8-2-2.4-1.7-3.9c0.3-1.5,1.4-2.7,3-3.1c17-3.7,37.5-20.7,66.5-55c1.4-1.6,3.8-1.8,5.4-0.4c1.6,1.4,1.8,3.8,0.4,5.4 c-25.9,30.6-45.6,48-62.6,54.9l40.5,25.8c1.1,0.7,2.4,1.3,3.5,1.7c0,0,0,0,0,0c3.9,0.6,19.4-0.2,52.3-35.8 c1.4-1.6,3.9-1.7,5.4-0.2c1.6,1.4,1.7,3.9,0.2,5.4C135.2,308.5,117.6,314.4,108.7,314.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,102.5c-1.4,0-2.8-0.8-3.5-2.2C107,69.4,100,42.2,101.1,22.4L58.7,49.8c-1.2,0.7-2.2,1.6-2.9,2.5 c-1.3,1.7-3.7,1.9-5.4,0.6c-1.7-1.3-1.9-3.7-0.6-5.4c1.3-1.6,2.9-3,4.9-4.2l49.3-31.8c1.3-0.8,3-0.8,4.3,0.1 c1.3,0.9,1.9,2.4,1.6,4C105.9,34,112.5,63,128.4,97c0.9,1.9,0.1,4.2-1.9,5.1C126.1,102.4,125.5,102.5,125,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.2,197.7c-1,0-2-0.4-2.7-1.1c-14.6-14.6-47.3-20.9-77.4-25.1c-2.1-0.3-3.6-2.2-3.3-4.3 c0.3-2.1,2.3-3.6,4.3-3.3c27.6,3.9,57.5,9.5,75.2,21.8v-48.1c0-1.3-0.2-3-0.4-4.2c-0.8-1.8-7-13.1-46.1-21.5 c-2.1-0.4-3.4-2.5-3-4.6c0.4-2.1,2.5-3.4,4.6-3c43,9.2,50.6,22.9,51.9,26.8c0.1,0.2,0.1,0.4,0.1,0.6c0.3,1.7,0.6,3.9,0.6,5.8 v56.2c0,1.6-0.9,3-2.4,3.6C323.2,197.6,322.7,197.7,322.2,197.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,198.2c-0.5,0-1-0.1-1.5-0.3c-1.4-0.6-2.4-2-2.4-3.6v-56.5c0-2.1,0-4.2,0.7-6.4c0.1-0.2,0.1-0.3,0.2-0.5 c3-6.1,24.8-36.1,159.8-36.1c12.3,0,24.4,0.5,33.3,0.8l5.9,0.2c2.1,0.1,3.8,1.8,3.7,4c-0.1,2.1-1.9,3.8-4,3.7l-5.9-0.2 c-8.8-0.3-20.8-0.8-33-0.8c-131.2,0-151.1,28.7-152.8,31.6c-0.3,1-0.3,2.2-0.3,3.7v48.4c14-9.7,37.5-16.5,75.7-22.3 c24.7-3.5,48.1-5.3,71.6-5.5h10.1c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8h-10c-23.1,0.3-46.1,2-70.5,5.4 c-28.7,4.3-63.5,11.1-77.9,25.5C10.6,197.8,9.6,198.2,8.6,198.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.9,225.2c-0.9,0-1.7-0.3-2.5-0.9c-1.6-1.4-1.9-3.8-0.5-5.4c1.8-2.1,5.6-8.2,9.4-14 c1.7-2.6,3.4-5.3,4.9-7.7C289.9,86.9,276.7,55,275.1,52c-0.7-0.8-1.6-1.6-2.6-2.2l-42.6-27.5c1.7,38.5-30.8,102.8-61.1,148.6 c-1.2,1.8-3.6,2.3-5.3,1.1c-1.8-1.2-2.3-3.6-1.1-5.3c41.2-62.4,64.9-123.2,59-151.2c-0.3-1.5,0.3-3.1,1.6-4 c1.3-0.9,3-0.9,4.3-0.1l49.4,31.8c1.8,1.1,3.5,2.5,4.8,4.1c0.1,0.1,0.2,0.3,0.3,0.4c3.4,5.7,16.9,40.1-56.9,153.6 c-1.6,2.4-3.2,5-4.9,7.6c-4.1,6.3-7.9,12.3-10,14.8C209.1,224.7,208,225.2,206.9,225.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.9,316c-9.1,0-46.2-7.6-115.5-114.3c-6.5-10.2-15.1-24.3-19.6-31.8l-0.2-0.4c-0.7-1.1-0.7-2.5-0.2-3.6 s1.7-2,2.9-2.1c25-3.5,49.1-5.2,71.9-5.2c1.3,0,2.6,0.7,3.3,1.8c0.7,1.1,1.4,2.1,2.1,3.2c0.8,1.1,1.6,2.3,2.3,3.4 c12.4,18.8,25.9,36.8,40,53.6c26.2,30.5,50.7,49.6,69,53.9c1.5,0.3,2.6,1.6,2.9,3.1c0.3,1.5-0.4,3-1.7,3.9l-49.1,31.8 c-1.4,0.8-3.3,1.9-5.5,2.6c-0.2,0.1-0.4,0.1-0.6,0.1C223.4,315.9,222.8,316,221.9,316z M96.1,170.5c4.7,7.8,11.4,18.7,16.7,27 c71.5,110,106.4,110.9,109.5,110.8c1.1-0.4,2.4-1,3.5-1.7l42.2-27.3c-18.6-7.4-41.3-26.2-65.1-53.8c0,0,0,0,0,0 c-14.3-17-27.9-35.3-40.6-54.4c-0.7-1.1-1.4-2.2-2.2-3.2c-0.4-0.5-0.7-1.1-1.1-1.6C139.1,166.2,117.9,167.7,96.1,170.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.8,103.1c-0.7,0-1.4-0.2-2.1-0.6c-1.8-1.2-2.3-3.5-1.1-5.3c20-30.7,32.3-44.5,32.8-45.1 c1.4-1.6,3.9-1.7,5.4-0.3c1.6,1.4,1.7,3.8,0.3,5.4c-0.1,0.1-12.5,14-32.1,44.1C137.2,102.4,136,103.1,134.8,103.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,224c-0.5,0-1-0.1-1.5-0.3c-2-0.8-2.9-3.1-2.1-5c0.7-1.7,17.6-42.5,31.2-54.1c1.6-1.4,4-1.2,5.4,0.4 c1.4,1.6,1.2,4-0.4,5.4c-10.1,8.7-24.4,39.9-29.1,51.2C62.6,223.1,61.2,224,59.7,224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.5,220.4c-1.6,0-3-1-3.6-2.5c-3.2-8.7-13.3-23.7-28.4-42.2c-1.3-1.6-1.1-4.1,0.5-5.4 c1.6-1.3,4.1-1.1,5.4,0.5c11.1,13.5,25.2,32.2,29.7,44.5c0.7,2-0.3,4.2-2.3,4.9C269.4,220.3,268.9,220.4,268.5,220.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamsLogoNoGnuPackage);
export default __webpack_public_path__ + "static/media/jams_logo_no_gnu_package.33315b1717d479fd19dec0d1d218f9e6.svg";
export { ForwardRef as ReactComponent };